.grantsList {
	@apply yst-space-y-3;
}

.loading {
	@apply yst-text-slate-500 yst-py-4;
}

.errorContent {
	@apply yst-flex yst-items-center yst-gap-4;
}

.retryButton {
	@apply yst-whitespace-nowrap;
}

.emptyState {
	@apply yst-text-slate-500;
}
